
$(document).ready(function () {
  /////////////////start//////////////

  let popup_kinder_quantity_range = 0;
  let changeMealVal = '';
  let popup_menu_prefe_selected = '';
  let add_prefe_selected = '';
  let device_prefe_selected = '';
  let meals_accounting_selected = '';
  let delivery_date_selected = '';
  popup_kinder_quantity_range = $('.sidebar-kinder-popup').val();
  if(popup_kinder_quantity_range){
  }else{
    popup_kinder_quantity_range = safeNumberConversionPopup($('#js-change-portion-selected').val());
  }
   
  changeMealVal = $('#js-change-meal-selected-text').text().trim();

  popup_menu_prefe_selected = $('input[name="change_mealPreference"]:checked').data('preference-value') || '';
  add_prefe_selected = $('input[name="change_addPrefernce"]:checked').data('addi-preference-value') || '';
  device_prefe_selected = $('input[name=" "]:checked').data('device-attr') || '';
  meals_accounting_selected = $('input[name="meals-accounting"]:checked').data('meal-accounting') || '';

  // Use :visible here to get the selected/visible value
  delivery_date_selected = $('.delivery-summary__date-input-popup:visible').val() || '';

  $(document).on('click', '#js-change-portion-select li', function () {
  // Get the text from the clicked li
  var selectedText = $(this).text().trim();

  // Set that text as the value of #js-change-portion-selected
  $('#js-change-portion-selected').val(selectedText).attr('value', selectedText);

  // Add active class handling (optional, visual feedback)
  $('#js-change-portion-select li').removeClass('active');
  $(this).addClass('active');

  // Trigger the change event manually so your main handler runs
  $('#js-change-portion-selected').trigger('change');

  console.log('Portion changed →', selectedText);
});

  $(document).on('change click',
    `
  .sidebar-kinder-popup,
   #js-change-meal-selected-text,
   input[name="change_qut"],
   input[name="change_mealPreference"],
   input[name="change_addPrefernce"],
   input[name="change_devices"],
   input[name="meals-accounting"],
   #js-change-meals-select li,
   .delivery-summary__date-input-popup`, // NO :visible here
    function () {   
       popup_kinder_quantity_range = $('.sidebar-kinder-popup').val();
       if(popup_kinder_quantity_range){
       }else{
         popup_kinder_quantity_range = Number($('#js-change-portion-selected-text').text());
       }
      changeMealVal = $('#js-change-meal-selected-text').text().trim();
 
      popup_menu_prefe_selected = $('input[name="change_mealPreference"]:checked').data('preference-value') || '';
      add_prefe_selected = $('input[name="change_addPrefernce"]:checked').data('addi-preference-value') || '';
      device_prefe_selected = $('input[name=" "]:checked').data('device-attr') || '';
      meals_accounting_selected = $('input[name="meals-accounting"]:checked').data('meal-accounting') || '';

      // Use :visible here to get the selected/visible value
      delivery_date_selected = $('.delivery-summary__date-input-popup:visible').val() || '';

      setTimeout(() => {
        popup_selector();
      }, 20);
    });



  //  -------- code for get device variant price staticaly using product handle code start here -------------
  let popup_device_price_var_1 = ""
  let popup_device_price_var_2 = ""
  let popup_device_price_var_3 = ""

  let popup_device_image_var_1 = ""
  let popup_device_image_var_2 = ""
  let popup_device_image_var_3 = ""

  let popup_device_id_var_1 = ""
  let popup_device_id_var_2 = ""
  let popup_device_id_var_3 = ""

  let popup_flex_flg = true;
  let popup_plan_text = 'FLEX';

  function popup_selector() {
    if (!$('#custom-config-modal').length) {
      return;
    }

    if ($('.order_pre_flex_abo').hasClass('order_pre_abo')) {
      popup_flex_flg = false;
      popup_plan_text = 'ABO';
    }

    if (popup_flex_flg) {
      jQuery.getJSON('/products/chinuki-device-flex-product.js', function (data12) {
        popup_device_price_var_1 = Number.parseFloat(data12.variants[0].price / 100).toFixed(2);
        popup_device_price_var_2 = Number.parseFloat(data12.variants[1].price / 100).toFixed(2);
        popup_device_price_var_3 = Number.parseFloat(data12.variants[2].price / 100).toFixed(2);
        
        popup_device_image_var_1 = data12.variants[0].featured_image.src;
        popup_device_image_var_2 = data12.variants[1].featured_image.src;
        popup_device_image_var_3 = data12.variants[2].featured_image.src;
        popup_device_id_var_1 = data12.variants[0].id;
        popup_device_id_var_2 = data12.variants[1].id;
        popup_device_id_var_3 = data12.variants[2].id;
      })
    } else {
      jQuery.getJSON('/products/chinuki-device-abo-product.js', function (data12) {
        popup_device_price_var_1 = Number.parseFloat(data12.variants[0].price / 100).toFixed(2);
        popup_device_price_var_2 = Number.parseFloat(data12.variants[1].price / 100).toFixed(2);
        popup_device_price_var_3 = Number.parseFloat(data12.variants[2].price / 100).toFixed(2);
        popup_device_image_var_1 = data12.variants[0].featured_image.src;
        popup_device_image_var_2 = data12.variants[1].featured_image.src;
        popup_device_image_var_3 = data12.variants[2].featured_image.src;
        popup_device_id_var_1 = data12.variants[0].id;
        popup_device_id_var_2 = data12.variants[1].id;
        popup_device_id_var_3 = data12.variants[2].id;
      })
    }

    let popup_get_pro_handle = '';
    if ($('.order_pre_flex_abo').length) {
      popup_get_pro_handle = $('.order_pre_flex_abo').attr('data-product-handle');
    }

    jQuery.getJSON('/products/' + popup_get_pro_handle + '.js', function (data2) {

      //  ----------- Product variant selector code --------------

      var variant_structure = [];
      for (let i = 0; i < data2.variants.length; i++) {
        var new_pro_title = data2.variants[i].title;
        var new_pro_id = data2.variants[i].id;

        if (data2.variants[i].featured_image != null) {
          var new_pro_feature_img = data2.variants[i].featured_image.src;
        } else {
          var new_pro_feature_img = data2.featured_image;
        }

        var new_pro_price = data2.variants[i].price;
        var pri_update = parseFloat(new_pro_price / 100);
        variant_structure += '<option data-attr="' + new_pro_title + '" value=' + data2.variants[i].id + ' data-option1="' + data2.variants[i].option1 + '" data-option2="' + data2.variants[i].option2 + '" data-option3="' + data2.variants[i].option3 + '" data-price="' + pri_update + '" data-var-img="' + new_pro_feature_img + '">' + new_pro_title + '</option>';
        $("#csp-product-variant-list").html(variant_structure);
      }
    })
      .done(function () {

        let popup_demoats = [];
        let popup_myVar2 = [];
        // var popup_menu_dishes_selected = "";
        // var popup_menu_prefe_selected = "";
        // var popup_menu_addi_prefe_selected = "";
        // popup_menu_dishes_selected = $("#js-change-meals-select li.active").attr('data-meals-value');
        // popup_menu_prefe_selected = $('input[name="change_mealPreference"]:checked').attr('data-preference-value');
        // popup_menu_addi_prefe_selected = $('input[name="change_addPrefernce"]:checked').attr('data-addi-preference-value');
        popup_demoats.push(changeMealVal + ' Tage');
        popup_demoats.push(popup_menu_prefe_selected);
        popup_demoats.push(add_prefe_selected);
        popup_myVar2 = popup_demoats.join(' / ');
        $("#csp-product-variant-list option").each(function () {
          var popup_d_option = $(this).data('attr');
          if (popup_d_option.indexOf(popup_myVar2) != -1) {
            var demnstar = $(this).attr('value');
            $(this).attr('selected', true).siblings().attr('selected', false);
            // $('.final-cart-btn').attr('data-pro-id', demnstar);    
            // var sel_var_img = $('#product-variant-list :selected').data("var-img");
            // $('.config-box__variant-img img').attr("src",sel_var_img);         
          }
        });

        product_price_change_popup();

      });
  }

  //  -------- code for get device variant price staticaly using product handle code end here -------------

  function safeNumberConversionPopup(value) {
    // Ensure the value is a valid string before attempting to replace
    if (value == null || value === "") {
      return 0; // Return 0 for null or empty strings
    }

    // If the value is a string, try to clean it and extract numbers
    if (typeof value === "string") {
      // Attempt to remove non-numeric characters, except for . and -
      value = value.replace(/[^0-9.-]/g, '');
    }

    // Parse the value to a float
    var parsedValue = parseFloat(value);

    // Return 0 if the value is not a valid number
    return isNaN(parsedValue) ? 0 : parsedValue;
  }

  setTimeout(() => {
    $('.sidebar-kinder-popup').change();
  }, 1500);

  function product_price_change_popup() {

    if ($('#cps_withDevice').is(':checked')) {
      // var quantity_range = $('.sidebar-kinder-popup').val();
      if (popup_kinder_quantity_range >= 4 && popup_kinder_quantity_range <= 10) {
      
        var popup_dp_price = safeNumberConversionPopup(popup_device_price_var_1)
        $('#cps_withDevice').attr('data-pro-price', popup_dp_price);
        $('#js-sous-img img').attr('src', popup_device_image_var_1)
      } else if (popup_kinder_quantity_range >= 11 && popup_kinder_quantity_range <= 20) {
        var popup_dp_price = safeNumberConversionPopup(popup_device_price_var_2)
        $('#cps_withDevice').attr('data-pro-price', popup_dp_price);
        $('#js-sous-img img').attr('src', popup_device_image_var_2)
      } else if (popup_kinder_quantity_range >= 21 && popup_kinder_quantity_range <= 50) {
        var popup_dp_price = safeNumberConversionPopup(popup_device_price_var_3)
        $('#cps_withDevice').attr('data-pro-price', popup_dp_price);
        $('#js-sous-img img').attr('src', popup_device_image_var_3)
      }
    }

    var popup_sel_pro_pri = safeNumberConversionPopup($('#csp-product-variant-list :selected').data("price"));
    
    //  var popup_kinder_quantity_range = $('.sidebar-kinder-popup').val();
    //  var change_portion_text = safeNumberConversionPopup($('#js-portion-select li.active').attr('data-quantity'));   
    //  if(change_portion_text >=1 && change_portion_text <=5){
    //    $('#js-portion-text').text($('.range_1-5').text());
    //  }
    //  if(change_portion_text >=6 && change_portion_text <=10){
    //    $('#js-portion-text').text($('.range_6-10').text());
    //  }
    //  if(change_portion_text >=11 && change_portion_text <=15){
    //    $('#js-portion-text').text($('.range_11-15').text());
    //  }
    //  if(change_portion_text >=16 && change_portion_text <=20){
    //    $('#js-portion-text').text($('.range_16-20').text());
    //  }
    //  if(change_portion_text >=21 && change_portion_text <=25){
    //    $('#js-portion-text').text($('.range_21-25').text());
    //  }
    //  if(change_portion_text >=26 && change_portion_text <=30){
    //    $('#js-portion-text').text($('.range_26-30').text());
    //  }
    //  if(change_portion_text > 30){
    //    $('#js-portion-text').text($('.range_30plus').text());
    //  }
    
    if ($('#cps_withDevice').is(':checked')) {
      var popup_votevalue = safeNumberConversionPopup(popup_dp_price);
      var popup_multiply_var_price = (popup_kinder_quantity_range * popup_sel_pro_pri) + popup_votevalue;
    }
    if ($('#cps_noDevice').is(':checked')) {
      var popup_multiply_var_price = (popup_kinder_quantity_range * popup_sel_pro_pri);
    }

    // Ensure popup_multiply_var_price is a valid number after the calculation 
    popup_multiply_var_price = safeNumberConversionPopup(popup_multiply_var_price);

    // console.log('*******');
    // console.log(popup_multiply_var_price);
    // console.log('++++');
    // console.log(popup_dp_price);
    // console.log(popup_kinder_quantity_range);
    // console.log(popup_sel_pro_pri);
    // console.log(popup_votevalue);
    var popup_step_price = Number.parseFloat(popup_multiply_var_price).toFixed(2);
    var popup_final_step_price = popup_step_price.toString().replace('.', ',');
    
    //  $('.config-box__price').html(popup_final_step_price);
    $('.config-box__price-popup').html(popup_final_step_price);

    // new configurator adjustment js code start here

    // var nca_popup_multiply_var_price = (popup_kinder_quantity_range*popup_sel_pro_pri);
    // //console.log(nca_popup_multiply_var_price);
    // var nfs = Number.parseFloat(nca_popup_multiply_var_price).toFixed(2);
    // var nfs_format = nfs.toString().replace('.', ',');
    // $('.multiplied-price').html(nfs_format);
    // $('.producttotalqty').html(popup_kinder_quantity_range*$("#js-meals-select li.active").text())
    // $('.productmealstotalqty').html($('#js-meals-select li.active').text());
    // var drs = Number.parseFloat(popup_sel_pro_pri).toFixed(2);
    // var drs_format = drs.toString().replace('.', ',');
    // $('.tax-multiplied-price').html(drs_format);
    //console.log(popup_kinder_quantity_range*$("#js-meals-select li.active").text());
    // new configurator adjustment js code ends here

  }

  $(document).on('click', '.popup-submit-button', function () {

    // const menu_dishes_selected = $('#js-change-meals-select li.active').attr('data-meals-value');
    // const menu_prefe_selected = $('input[name="change_mealPreference"]:checked').attr('csp-data-preference-value');
    // const menu_addi_prefe_selected = $('input[name="change_addPrefernce"]:checked').attr('csp-data-addi-preference-value');
    // const selected_dish_portion = $('#js-portion-selected-popup').val();
    const popup_selected_device_price = $('input[name="change_devices"]:checked').attr('data-pro-price') || '';
    // const selected_subscription_plan = $('input[name="orderPreferenceTrial"]:checked').attr('id') || '';
    const popup_customer_email = $(this).attr('data-customer-email');
    const popup_delivery_date_selected = $('#datePopup').val();
    const popup_onetime_delivery_date = popup_delivery_date_selected.replaceAll('.', '-');

    document.cookie = "onetimedeliverydate=" + popup_onetime_delivery_date;

    // demoats.push(menu_dishes_selected, menu_prefe_selected, menu_addi_prefe_selected);
    // myVar2 = demoats.join(' / ');

    // const productVariantSelect = $('#csp-product-variant-list');
    // const selected_option = productVariantSelect.find(`option[data-option1='${menu_dishes_selected}'][data-option2='${menu_prefe_selected}'][data-option3='${menu_addi_prefe_selected}']`);

    // const pro_id = selected_option.val();
    const popup_pro_id = $(this).attr('data-pro-id');
    const popup_selling_plan_id = $('input[name="change_devices"]:checked').attr('data-sell_id') || '';
    const popup_device_pro_id = $('input[name="change_devices"]:checked').attr('data-pro-id') || '';

    let popup_itemData = {
      items: []
    };

    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function () {
        //  console.log('cart clear'); 
        setTimeout(function () {
          product_add_cart_popup();
        }, 500);
      }
    });

    function product_add_cart_popup() {
      // let demoats = [];
      // let myVar2 = [];


      // First: add device product (if device selected)
      if (popup_device_pro_id) {
        popup_itemData.items.push({
          quantity: 1,
          id: popup_device_pro_id,
          properties: {
            'portion': popup_kinder_quantity_range,
            'device Price': popup_selected_device_price,
            'subscription plan': popup_plan_text,
            'customer email': popup_customer_email,
            'delivery_date': popup_delivery_date_selected
          },
          selling_plan: popup_selling_plan_id
        });
      }

      // Then: add main product
      popup_itemData.items.push({
        quantity: popup_kinder_quantity_range,
        id: popup_pro_id,
        properties: {
          'device': popup_device_pro_id ? "with device" : "without device",
          'device Price': popup_selected_device_price,
          'portion': popup_kinder_quantity_range,
          'subscription plan': popup_plan_text,
          'customer email': popup_customer_email,
          'delivery_date': popup_delivery_date_selected
        },
        selling_plan: popup_selling_plan_id
      });


      // Add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(popup_itemData)
      })
        .then(response => response.json())
        .then(datta => {
          $('#js-slider-config').removeClass('is-active');
          $('html').removeClass('is-slider-active');
          $('.slider-bg-overlay').removeClass('is-active');
          $('.slider__body--popup').addClass('hidden-popup');
          jQuery.getJSON('/cart.js', function (cartdata) {

            if (typeof window.chinukiAddToCartTracking === 'function') {
              window.chinukiAddToCartTracking(cartdata, function(updatedCart, gclid) {
                var baseUrl = $('#about-change-parent-meals-accounting').is(':checked')
                  ? window.ChinukiConfig.apiBaseUrl + '/daycare/register/'
                  : window.ChinukiConfig.apiBaseUrl + '/cart/';
                if (typeof window.chinukiGetGA4SessionParams === 'function') {
                  window.chinukiGetGA4SessionParams(function(clientId, sessionId) {
                    if (sessionId) updatedCart.session_id = sessionId;
                    var token = btoa(JSON.stringify(updatedCart));
                    var finalUrl = baseUrl + '?token=' + token;
                    if (gclid) finalUrl += '&gclid=' + encodeURIComponent(gclid);
                    if (clientId) finalUrl += '&client_id=' + encodeURIComponent(clientId);
                    window.location.href = finalUrl;
                  });
                } else {
                  var token = btoa(JSON.stringify(updatedCart));
                  var finalUrl = baseUrl + '?token=' + token + (gclid ? '&gclid=' + encodeURIComponent(gclid) : '');
                  window.location.href = finalUrl;
                }
              });
            } else {
              var baseUrl = $('#about-change-parent-meals-accounting').is(':checked')
                ? window.ChinukiConfig.apiBaseUrl + '/daycare/register/'
                : window.ChinukiConfig.apiBaseUrl + '/cart/';
              if (typeof window.chinukiGetGA4SessionParams === 'function') {
                window.chinukiGetGA4SessionParams(function(clientId, sessionId) {
                  if (sessionId) cartdata.session_id = sessionId;
                  var token = btoa(JSON.stringify(cartdata));
                  var finalUrl = baseUrl + '?token=' + token;
                  if (clientId) finalUrl += '&client_id=' + encodeURIComponent(clientId);
                  window.location.href = finalUrl;
                });
              } else {
                var token = btoa(JSON.stringify(cartdata));
                var finalUrl = baseUrl + '?token=' + token;
                window.location.href = finalUrl;
              }
            }
          });
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
        });
    }
  });


  /////////////////end//////////////
});